<template>
  <div>
    <ul class="text-left list-reset">
      <li v-for="opt in options"
        :key="opt.value"
        @click="handleSelectGuests(opt.value)"
        class="item"
        :class="{ 'is-selected': value === opt.value }">
        {{ opt.label }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export const TRAVELERS = [
  { value: '1', label: '1 traveler' },
  { value: '2', label: '2 travelers' },
  { value: '3', label: '3 travelers' },
  { value: '4', label: '4 travelers' },
  { value: '5', label: '5 travelers' },
  { value: '6', label: '6 travelers' },
  { value: '7', label: '7 travelers' },
  { value: '8', label: '8 travelers' },
  { value: '9', label: '9 travelers' },
  { value: '10+', label: 'More than 10 travelers' }
]

export default {
  data () {
    return {
      options: TRAVELERS
    }
  },
  computed: {
    ...mapState(['formData']),
    value () {
      return this.formData.guests
    }
  },
  methods: {
    handleSelectGuests (value) {
      this.$store.commit('setMobileFormData', {
        key: 'guests',
        value: value
      })
      this.$store.commit('setForceShowGuestsPicker', false)
    }
  }
}
</script>

<style scoped>
.item {
  height: 42px;
  line-height: 42px;
}

.item.is-selected {
  position: relative;
}

.is-selected::after {
  content: '';
  position: absolute;
  background-color: var(--black-light-2);
  width: calc(100% + 48px);
  height: 100%;
  left: -24px;
  z-index: -1;
}
</style>